function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 29.5,
  cy: 31.974,
  r: 23.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M28 8.827c4.28 6.88 6.732 15.658 6.464 25.114-.23 8.1-2.42 15.524-5.971 21.559M26.704 52.502C16.709 51.007 8.743 42.386 8.743 31.974c0-10.333 7.55-18.902 17.434-20.493"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(13.897)",
  cx: 20.968,
  cy: 22.232,
  rx: 2.5,
  ry: 0.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.329,
  cy: 31.622,
  rx: 2.5,
  ry: 0.5
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "scale(-1 1) rotate(7.851)",
  cx: -9.782,
  cy: 38.423,
  rx: 2.5,
  ry: 0.5
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(20.278)",
  cx: 23.32,
  cy: 14.739,
  rx: 2.5,
  ry: 0.5
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(-.96589 .25895 .26002 .9656 0 0)",
  cx: -5.358,
  cy: 44.688,
  rx: 2.499,
  ry: 0.499
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(-.90793 .41912 .42013 .90747 0 0)",
  cx: 1.767,
  cy: 50.075,
  rx: 2.499,
  ry: 0.499
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(30.72)",
  cx: 25.858,
  cy: 5.781,
  rx: 2.5,
  ry: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.62 55.5C25 49 22.322 39.842 22.533 30.386 22.713 22.286 25 14 28.232 8.827"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28 8.827c11.07 6.88 17.41 15.658 16.718 25.114-.593 8.1-6.26 15.524-15.444 21.559"
})), /*#__PURE__*/React.createElement("path", {
  d: "M23 1c-2.186 4.503 2.264 6.226 5.231 7.827"
}));

var SvgWatermelon = function SvgWatermelon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWatermelon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Watermelon.306cf739.svg";
export { ForwardRef as ReactComponent };